import React, { useEffect, useState } from 'react';
import { View, Text } from 'react-native';
import { SVG_COMPONENTS } from '@/assets/admin';
import { ADMIN_COLORS } from '@/constants/admin';
import { formatTaskDate, getDueDateColor, getDueDateInfo } from '@/utils/admin/date';

export const TaskDueDate = ({ dueDate, status }: { dueDate?: string | Date | null; status: string }) => {
  const info = getDueDateInfo(dueDate as any, status);
  const color = getDueDateColor(dueDate as any);

  const ProgressRing: React.FC<{ progress: number; color: string; size?: number; strokeWidth?: number; children?: React.ReactNode }>
    = ({ progress, color, size = 20, strokeWidth = 2, children }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const dashOffset = circumference * (1 - (progress || 0));

    const g: any = (globalThis as any);
    if (g && g.document) {
      return (
        <View style={{ width: size, height: size, alignItems: 'center', justifyContent: 'center', marginRight: 6 }}>
          <svg width={size} height={size}>
            <circle cx={size / 2} cy={size / 2} r={radius} stroke={'rgba(255,255,255,0.06)'} strokeWidth={strokeWidth} fill={'none'} />
            <circle cx={size / 2} cy={size / 2} r={radius} stroke={color} strokeWidth={strokeWidth} strokeDasharray={`${circumference} ${circumference}`} strokeDashoffset={dashOffset} strokeLinecap={'round'} fill={'none'} transform={`rotate(-90 ${size / 2} ${size / 2})`} />
          </svg>
          <View style={{ position: 'absolute', width: size, height: size, alignItems: 'center', justifyContent: 'center' }}>{children}</View>
        </View>
      );
    }

    const [SvgModule, setSvgModule] = useState<any>(null);
    useEffect(() => { import('react-native-svg').then(setSvgModule).catch(() => {}); }, []);
    const SvgComp = SvgModule?.default;
    const CircleComp = SvgModule?.Circle;
    return (
      <View style={{ width: size, height: size, alignItems: 'center', justifyContent: 'center', marginRight: 6 }}>
        {SvgComp && CircleComp ? (
          <SvgComp width={size} height={size}>
            <CircleComp cx={size / 2} cy={size / 2} r={radius} stroke={'rgba(255,255,255,0.06)'} strokeWidth={strokeWidth} fill={'none'} />
            <CircleComp cx={size / 2} cy={size / 2} r={radius} stroke={color} strokeWidth={strokeWidth} strokeDasharray={`${circumference} ${circumference}`} strokeDashoffset={dashOffset} strokeLinecap={'round'} fill={'none'} transform={`rotate(-90 ${size / 2} ${size / 2})`} />
          </SvgComp>
        ) : null}
        <View style={{ position: 'absolute', width: size, height: size, alignItems: 'center', justifyContent: 'center' }}>{children}</View>
      </View>
    );
  };

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
      {info.isLongOverdue ? (
        <View style={{ width: 20, height: 20, borderRadius: 10, alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,0.06)', borderWidth: 1, borderColor: ADMIN_COLORS.BORDER }}>
          <Text style={{ color: '#F87171', fontWeight: '800' }}>!</Text>
        </View>
      ) : (
        dueDate ? (
          <ProgressRing progress={info.progress} color={color}>
            <SVG_COMPONENTS.CALENDAR width={14} height={14} color={color} />
          </ProgressRing>
        ) : (
          <SVG_COMPONENTS.CALENDAR width={14} height={14} color={color} />
        )
      )}
      <Text numberOfLines={1} style={{ fontSize: 12, color }}>{formatTaskDate(dueDate as any)}</Text>
    </View>
  );
};


